import React, { useState, useEffect, useContext, useCallback } from "react";
import taxoApi from "../../api/taxoApi";
import { Context } from "../../commons/utils/store";
import "../../App-media.css";
import { Form } from "react-bootstrap";
import TableDimensions from "../../commons/table/tableDimensions";
import FileUploadModal from "../../commons/uploadFile/FileUploadModal";
import { NOMBRE_TABLA_LABELS, COLUMN_LABELS } from "../../commons/utils/store";
import { UsuarioAutenticadoContext } from "../../context/authenticatedUser";
import './DimensionsPage.css'

export default function DimensionsPage(props) {
  const DEFAULT_TABLE = "T_TAXUE_PROVINCIAS";
  const [tableOption, setTableOption] = useState(DEFAULT_TABLE);
  const [dimensions, setDimensions] = useState([{ NOMBRE_TABLA: DEFAULT_TABLE, APODO_TABLA: NOMBRE_TABLA_LABELS[DEFAULT_TABLE] || DEFAULT_TABLE }]);
  const [, dispatch] = useContext(Context);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const { usuarioAutenticado } = useContext(UsuarioAutenticadoContext);
  
  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleObtainDimensionsByEntity = useCallback((id_entidad) =>
    taxoApi.getDimensionByEntity(id_entidad).then((response) => {
      if (Array.isArray(response) && response.length > 0) {
        setDimensions(response);
        const found = response.find(dim => dim.NOMBRE_TABLA === DEFAULT_TABLE);
        const selected = found ? found.NOMBRE_TABLA : response[0].NOMBRE_TABLA;
        setTableOption(selected);
        return selected;
      }
      return null;
    }), []);

  const handleObtainDimensions = useCallback((tableName) =>
    tableName
      ? taxoApi.getDimension(tableName).then((response) => {
          const dataArray = Array.isArray(response) ? response : [];
          const cleanedResponse = dataArray.map((item) => {
            const { COMENTARIOS, F_CREACION, F_BAJA, F_MODIFICACION, ID_ENTIDAD, ...rest } = item;
            return rest;
          });
          setData(cleanedResponse);
        })
      : Promise.resolve(), []);

  useEffect(() => {
    let isMounted = true;
    dispatch({ type: "SET_HIDDEN", payload: false });

    const id_entidad = String(usuarioAutenticado?.id_entidad)

    handleObtainDimensionsByEntity(id_entidad).then((firstTable) => {
      if (isMounted) {
        handleObtainDimensions(firstTable).finally(() => {
          if (isMounted) dispatch({ type: "SET_HIDDEN", payload: true });
        });
      }
    });

    return () => { isMounted = false; };
  }, [dispatch, handleObtainDimensionsByEntity, handleObtainDimensions]);

  useEffect(() => {
    let isMounted = true;
    if (tableOption) {
      dispatch({ type: "SET_HIDDEN", payload: false });
      handleObtainDimensions(tableOption).finally(() => {
        if (isMounted) dispatch({ type: "SET_HIDDEN", payload: true });
      });
    }
    return () => { isMounted = false; };
  }, [dispatch, tableOption, handleObtainDimensions]);

  const onSuccess = () => {
    dispatch({ type: "SET_HIDDEN", payload: false });
    handleObtainDimensions(tableOption).finally(() => {
      dispatch({ type: "SET_HIDDEN", payload: true });
      handleClose();
    });
  }

  return (
    <React.Fragment>
      <div className="section-block first-block">
        <div className="principal-title">
          <span className="header-title d-inline">
            Visualización de dimensiones
          </span>
        </div>
      </div>
      <div className="section-block position-relative tabs-home">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="col-3">
            <Form.Select
              aria-label="selector de dimensión"
              value={tableOption}
              onChange={(e) => setTableOption(e.target.value)}
            >
              {dimensions.map((dim) => (
                <option key={dim.NOMBRE_TABLA} value={dim.NOMBRE_TABLA}>
                  {NOMBRE_TABLA_LABELS[dim.NOMBRE_TABLA] || dim.APODO_TABLA}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="col-3 d-flex justify-content-end">
            <button
              className="btn btn-primary d-none"
              onClick={handleShow}
              disabled={!tableOption}
            >
              Subir documento de dimensiones
            </button>
          </div>
        </div>
        <div className="table-responsive-x oculta-scrollbar">
          <TableDimensions data={data} size={10} columnLabels={COLUMN_LABELS} />
        </div>
      </div>
      <FileUploadModal show={showModal} handleClose={handleClose} onSuccess={onSuccess} />
    </React.Fragment>
  );
}
